import * as React from 'react';
import * as PropTypes from 'prop-types';
import Select, { components } from 'react-select';
import classnames from 'classnames';
import DropdownIndicator from '../DropdownIndicator';
import ClearIndicator from '../ClearIndicator';

interface ICheckboxMultiSelect {
    options: any[];
    onChangeCallback: (response: any) => void;
    value?: any;
    disabled?: boolean;
}

class CheckboxMultiSelect extends React.Component<ICheckboxMultiSelect, null> {
    static propTypes = {
        options: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.node,
                label: PropTypes.node
            })
        ).isRequired,
        onChangeCallback: PropTypes.func.isRequired
    };

    render() {
        const {
            options,
            onChangeCallback,
            value,
            disabled,
            ...otherProps
        } = this.props;
        return (
            <Select
                value={value}
                closeMenuOnSelect={false}
                isMulti
                options={options}
                hideSelectedOptions={false}
                backspaceRemovesValue={false}
                onChange={(e) => onChangeCallback(e)}
                isDisabled={disabled}
                {...otherProps}
                className={'form-select--react-select react-select'}
                classNamePrefix={'react-select'}
                components={{
                    Option,
                    MultiValue,
                    DropdownIndicator,
                    ClearIndicator
                }}
            />
        );
    }
}

const Option = (props) => {
    return (
        <components.Option
            {...props}
            onClick={() => props.selectOption(props.data)}
            className={classnames('react-select-option--checkbox', {
                'option--selected': props.isSelected,
                'option--focused': props.isFocused,
                'option--disabled': props.isDisabled
            })}
        >
            <input type="checkbox" checked={props.isSelected} readOnly />{' '}
            <label>{props.label}</label>
        </components.Option>
    );
};

const MultiValue = (props) => (
    <components.MultiValue {...props}>
        <span>{props.data.label || props.data.title}</span>
    </components.MultiValue>
);

export default CheckboxMultiSelect;
